import { ChangeEvent, FC } from 'react'

import styled, { css } from 'styled-components'

import CheckboxCheckedIcon from 'src/Assets/Svg/pages-icons/CheckboxChecked.svg?react'
import CheckboxIcon from 'src/Assets/Svg/pages-icons/Checkbox.svg?react'
import { variables } from 'src/Styled/variables'

export interface AutoRenewBlockProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
}

const HiddenCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 0;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`

const IconWrapper = styled.div<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  .CheckboxIcon {
    width: 16px;
    height: 16px;
    stroke: ${({ $disabled, theme }) =>
      $disabled ? theme.color.lightGrey : theme.color.darkGrey};
  }

  .CheckboxCheckedIcon {
    width: 16px;
    height: 16px;
    ${({ $disabled, theme }) =>
      $disabled &&
      css`
        stroke: ${theme.color.lightGrey};
        rect {
          fill: transparent;
        }
      `}
  }
`

const LabelContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  min-width: 0;
`

const LabelText = styled.span<{ $disabled?: boolean }>`
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  min-width: 0;
  color: ${({ $disabled, theme }) =>
    $disabled ? theme.color.slateGrey : theme.color.darkGrey};
`

const Badge = styled.span`
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize12};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  border-radius: 16px;
  padding: 3px 6px;
  background-color: ${({ theme }) => theme.color.lightGreen};
  color: ${({ theme }) => theme.color.darkGreen};
  white-space: nowrap;
`

const Container = styled.label<{ $disabled?: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.color.lightGrey};
  background-color: ${({ theme }) => theme.color.white};
  cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
  width: 100%;
  height: 58px;
  box-sizing: border-box;
`

export const AutoRenewBlock: FC<AutoRenewBlockProps> = ({
  checked,
  onChange,
  disabled,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    onChange(e.target.checked)
  }

  return (
    <Container $disabled={disabled}>
      <HiddenCheckbox
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <IconWrapper $disabled={disabled}>
        {checked ? (
          <CheckboxCheckedIcon className='CheckboxCheckedIcon' />
        ) : (
          <CheckboxIcon className='CheckboxIcon' />
        )}
      </IconWrapper>
      <LabelContent>
        <LabelText $disabled={disabled}>Auto-renew campaign</LabelText>
        <Badge>Recommended</Badge>
      </LabelContent>
    </Container>
  )
}
